<template
  ><b-container>
    <b-row class="mb-4">
      <b-col>
        <b-row class="mb-n1">
          <b-col
            ><div class="tsny_text">
              Posted in <span class="font-weight-bold">{{ courses }}</span>
            </div></b-col
          >
        </b-row>
        <b-row>
          <b-col
            ><div class="tsny_text font-weight-bold">
              {{ question.topic }}
            </div></b-col
          >
        </b-row></b-col
      ><b-col
        ><b-row
          ><b-col v-if="canEdit"
            ><b-button class="tsny_button" @click="$emit('update-question')"
              >Edit Question</b-button
            ></b-col
          ><b-col v-if="isAdmin"
            ><b-button class="tsny_button" @click="$emit('delete-question')"
              >Delete Question</b-button
            ></b-col
          ></b-row
        ></b-col
      >
    </b-row>
    <b-row class="mb-1">
      <b-col
        ><h2 class="tsny_header">{{ question.question }}</h2></b-col
      > </b-row
    ><b-row class="mb-n1">
      <b-col
        ><div class="tsny_text">
          Posted by
          <span class="font-weight-bold">{{ question.askedBy }}</span>
        </div></b-col
      > </b-row
    ><b-row class="mb-3">
      <b-col
        ><div class="tsny_text">
          {{ askedAtFormatted }}
        </div></b-col
      >
    </b-row>
    <b-row class="mb-4">
      <b-col
        ><div class="tsny_text">{{ question.description }}</div></b-col
      >
    </b-row>
    <b-row class="tsny_box-padding tsny_box-fill" v-if="question.answer">
      <b-col>
        <b-row class="mb-n1"
          ><b-col
            ><div class="tsny_text">
              Posted by
              <span class="font-weight-bold">{{ question.answeredBy }}</span>
            </div></b-col
          ></b-row
        >
        <b-row class="mb-2"
          ><b-col
            ><div class="tsny_text">
              {{ answeredAtFormatted }}
            </div></b-col
          ></b-row
        >
        <b-row>
          <b-col>
            <div class="tsny_text">{{ question.answer }}</div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container></template
>

<script>
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "QuestionDetail",
  props: {
    question: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: StoreConstants.GETTERS.IS_ADMIN,
      courseNames: StoreConstants.GETTERS.COURSE_NAMES,
      user: StoreConstants.GETTERS.USER
    }),
    courses() {
      return this.question.courses.join(", ");
    },
    canEdit() {
      return this.isAdmin || this.user === this.question.assignedTo;
    },
    askedAtFormatted() {
      return moment(this.question.askedAt).format("M/D LT");
    },
    answeredAtFormatted() {
      return moment(this.question.answeredAt).format("M/D LT");
    }
  },
  methods: {
    editQuestion() {}
  }
};
</script>

<style scoped></style>
